'use es6';

import { Record, Map as ImmutableMap } from 'immutable';
import { FORM_FIELD_TYPES } from 'MeetingsBase/constants/enums';

function getInitialCustomFieldState(formFields) {
  return formFields.reduce((acc, field) => {
    if (field.fieldType === FORM_FIELD_TYPES.BOOLEAN_CHECKBOX) {
      return acc.set(field.name, false);
    } else if (field.fieldType === FORM_FIELD_TYPES.CHECKBOX) {
      return acc.set(field.name, []);
    } else {
      return acc.set(field.name, null);
    }
  }, new ImmutableMap());
}

const defaults = {
  email: '',
  firstName: '',
  lastName: '',
  customFormFields: new ImmutableMap(),
  originalFormState: null
};
export default class FormState extends Record(defaults) {
  static from(json) {
    json.customFormFields = new ImmutableMap(json.customFormFields);
    const jsonMap = ImmutableMap(json).filter(value => value !== undefined);
    return new FormState(jsonMap);
  }

  static customFieldsFromBookInfo(json) {
    const formFields = json.customParams.formFields;
    const customFormFields = getInitialCustomFieldState(formFields);
    return customFormFields;
  }

}